export const dialog = async (...args) => {
	return window.alert(...args);
};
export const commonError = async e => {
	return window.alert(e.message);
};
export const confirm = async (...args) => {
	return window.confirm(...args);
};
